/* eslint-disable */
import { useState, useEffect } from "react";
import { ethers, BigNumber } from "ethers";
import { useModal } from "../../../utils/ModalContext";
import { Slider, SliderItem } from "../../../common/slider/Slider";
import { FiX } from "react-icons/fi";
import axios from "axios";
// import thumb1 from "../../../assets/images/nft/land-plot1.jpg";
// import thumb2 from "../../../assets/images/nft/land-plot2.jpg";
// import thumb3 from "../../../assets/images/nft/land-plot3.jpg";
// import thumb4 from "../../../assets/images/nft/land-plot4.jpg";
import checkIcon from "../../../assets/images/icon/mint-right-text-icon.svg";
import twitterIcon from "../../../assets/images/icon/Twitter.svg";
import Button from "../../button";
import MintModalStyleWrapper from "./MintNow.style";
import mintImg from "../../../assets/images/icon/mint-img.png";
import hoverShape from "../../../assets/images/icon/hov_shape_L.svg";
import LAND_ABI from "../../../abi/LANDRegistry.json";
import CandyMachine_ABI from "../../../abi/LANDRegistry.json";

import {
  TOPIC_RECLAIM_LAND,
  LAND_REGISTRY,
  GRID_W_H,
  TEXT_TWITTER,
  API_ENDPOINT,
} from "../../../utils/constants";

const slideImages = [];

const sliderSettings = {
  dots: false,
  arrows: true,
  autoplay: false,
  speed: 50,
  fade: true,
  autoplaySpeed: 500,
  centerMode: true,
  centerPadding: "10px",
  infinite: true,
  slidesToShow: 1,
  slidesToScroll: 1,
};

const MintNowModal = ({ logs }) => {
  const [count, setCount] = useState(1);
  const [landMinted, setLandMinted] = useState([]);
  const { closeLootModal } = useModal();

  const provider = new ethers.providers.Web3Provider(window.ethereum, "any");
  const signer = provider.getSigner();

  const LandContractInstance = new ethers.Contract(
    LAND_REGISTRY,
    LAND_ABI,
    signer
  );

  const landCoords = [];

  const logsArray = logs.events;

  useEffect(() => {
    logsArray
      .filter((log) => log.topics[0] == TOPIC_RECLAIM_LAND)
      .map((item) => {
        setLandMinted(item.args[1]);
      });
  }, [logsArray]);

  const getX = (tokenId) => {
    const unshiftedX = Math.floor(tokenId / (GRID_W_H * 2 + 1));
    return unshiftedX - GRID_W_H;
  };

  const getY = (tokenId) => {
    const unshiftedY = tokenId % (GRID_W_H * 2 + 1);
    return unshiftedY - GRID_W_H;
  };

  const tokenIds = [];

  landMinted.map((item) => {
    landCoords.push(`(${getX(item.toNumber())}, ${getY(item.toNumber())})`);
    slideImages.push(
      `https://api.coderblock.com/v2/nfts/parcels/${getX(
        item.toNumber()
      )}/${getY(item.toNumber())}/map.png`
    );
    tokenIds.push(item.toNumber());

    const dataPost = async () => {
      const ownerAddress = await signer.getAddress();

      axios
        .post(`${API_ENDPOINT}nfts/mints`, {
          data: {
            ownerAddress: ownerAddress,
            tokenIds: tokenIds,
          },
        })
        .then(
          (response) => {
            console.log(response);
          },
          (error) => {
            console.log(error);
            console.log(error.config.data);
          }
        );
    };

    dataPost();
  });


  const handleLandMapClick = () => {
    window.open("https://coderblock.com/lands", "_blank");
  };

  const handleLandManagerClick = () => {
    window.open(
      "https://coderblock.com/login?redirect_to=/admin/metaverse/auth",
      "_blank"
    );
  };

  const handleTwitterClick = () => {
    window.open(
      `https://twitter.com/intent/tweet?text=${TEXT_TWITTER}`,
      "_blank"
    );
  };

  return (
    <>
      <MintModalStyleWrapper className="modal_overlay">
        <div className="mint_modal_box">
          <div className="mint_modal_content">
            <div className="modal_header">
              <h2>
                <span>
                  <img src={checkIcon} alt="icon" />
                </span>
                THAT'S YOUR LOOT!
              </h2>
              <button onClick={() => closeLootModal()}>
                <FiX />
              </button>
            </div>
            <div className="modal_body text-center">
              <div className="mint_slider">
                <Slider {...sliderSettings}>
                  {slideImages?.map((thumb, idx) => {
                    const landCoord = landCoords[idx];
                    return (
                      <SliderItem key={idx}>
                        <div className="mint_thumb">
                          <img src={thumb} alt="thumb" />
                          <h5 className="mint_slider_text">{landCoord}</h5>
                        </div>
                      </SliderItem>
                    );
                  })}
                </Slider>
              </div>
              <div className="mint_count_list">
                <ul>
                  {/* <li>
                    <h5>Parcel</h5>
                    {landCoords.map((item, index) => {
                      return <h5 key={index}>{item}</h5>;
                    })}
                    ;
                  </li> */}
                  <li>
                    <h5>Quantity</h5>
                    <h5>{landMinted.length}</h5>
                  </li>
                </ul>
              </div>
              <div className="modal_mint_btn">
                {/* <Button lg variant="mint" onClick={() => handleMint()}>
                  Share on Twitter
                </Button> */}
                <Button lg variant="coder" onClick={() => handleLandMapClick()}>
                  View on map
                </Button>
                <Button
                  lg
                  variant="coder"
                  onClick={() => handleLandManagerClick()}
                >
                  Go to Land Manager
                </Button>
                <Button lg variant="coder" onClick={() => handleTwitterClick()}>
                  <img src={twitterIcon} alt="icon" />
                  share on twitter
                </Button>
              </div>
            </div>

            <div className="modal_bottom_shape_wrap">
              <span className="modal_bottom_shape shape_left">
                <img src={hoverShape} alt="bithu nft hover shape" />
              </span>
              <span className="modal_bottom_shape shape_right">
                <img src={hoverShape} alt="bithu nft hover shape" />
              </span>
            </div>
          </div>
        </div>
      </MintModalStyleWrapper>
    </>
  );
};

export default MintNowModal;
